import { ActionTypes } from "../constants";

const reduceSurveyTypes = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.GET_MSF_SURVEY_TYPES_SUCCESS:
            return action.data || [];

        case ActionTypes.LOGOUT:
            return null;

        default:
            return state;
    }
};

export default reduceSurveyTypes;
